// import { useEffect, useState } from "react";
// import useAxios from "../../../../Hooks/useAxios";

// const initDoc = [];

// function useTable() {
//   const [limit, setLimit] = useState(10);
//   const [docs, setDocs] = useState(initDoc);
//   const [isLoading, setIsLoading] = useState(true);

//   // Pagination
//   const [page, setPage] = useState(1);
//   const [hasNextPage, setHasNextPage] = useState(false);
//   const [hasPrevPage, setHasPrevPage] = useState(false);
//   const [total, setTotal] = useState(0);
//   const [pages, setPages] = useState(0);

//   const [order, setOrder] = useState("id-desc");
//   const request = useAxios();

//   const refetchDocs = () => getDocs({ page: page, limit: limit });

//   const [systemId, setSystemId] = useState(null);
//   const [showDeleteModal, setShowDeleteModal] = useState(false);

//   // Payment Status Filter
//   const [paymentStatuses, setPaymentStatuses] = useState([]);
//   const [selectedPaymentStatuses, setSelectedPaymentStatuses] = useState([]);
//   const [isFiltered, setIsFiltered] = useState(false);

//   useEffect(() => {
//     getDocs({ page, limit });
//     getPaymentStatuses();
//   }, [page, limit, order, selectedPaymentStatuses]);

//   useEffect(() => {
//     setIsFiltered(selectedPaymentStatuses.length > 0);
//   }, [selectedPaymentStatuses]);

//   async function getDocs({ page, limit }) {
//     let res = await request({
//       method: "GET",
//       url: "customers/all",
//       params: {
//         page,
//         limit,
//         order,
//         payment_status: selectedPaymentStatuses.join(","),
//       },
//       show_loading: false,
//       loadingFunc: setIsLoading,
//     });

//     if (res === "error") return;

//     setTotal(res?.pagination?.total || 0);
//     setPages(res?.pagination?.pages || 0);
//     setHasNextPage(res?.pagination?.hasNextPage || false);
//     setHasPrevPage(res?.pagination?.hasPrevPage || false);
//     setDocs(res?.docs || initDoc);
//   }

//   async function getPaymentStatuses() {
//     let res = await request({
//       method: "GET",
//       url: "payment-status/all",
//       show_loading: false,
//     });
//     if (res !== "error") setPaymentStatuses(res?.docs || []);
//   }

//   function handleNext() {
//     if (hasNextPage) setPage((prev) => prev + 1);
//   }

//   function handlePrev() {
//     if (hasPrevPage) setPage((prev) => prev - 1);
//   }

//   async function handleDelete(id) {
//     let res = await request({
//       method: "DELETE",
//       url: "customers/delete",
//       params: { id: parseInt(id) },
//     });

//     if (res !== "error") {
//       setShowDeleteModal(false);
//       refetchDocs();
//     }
//   }

//   async function clearFilters() {
//     setSelectedPaymentStatuses([]);
//     setIsFiltered(false);
//   }

//   return {
//     limit,
//     setLimit,
//     docs,
//     setDocs,
//     isLoading,
//     setIsLoading,
//     pagination: {
//       page,
//       total,
//       pages,
//       hasNextPage,
//       hasPrevPage,
//       handleNext,
//       handlePrev,
//       limit,
//       setLimit,
//       total_docs: docs.length || 0,
//     },
//     setOrder,
//     systemId,
//     setSystemId,
//     refetchDocs,
//     showDeleteModal,
//     setShowDeleteModal,
//     handleDelete,
//     paymentStatuses,
//     selectedPaymentStatuses,
//     setSelectedPaymentStatuses,
//     isFiltered,
//     clearFilters,
//   };
// }

// export default useTable;

import { useEffect, useState } from "react";
import useAxios from "../../../../Hooks/useAxios";

const initDoc = [];

function useTable() {
  const [limit, setLimit] = useState(10);
  const [docs, setDocs] = useState(initDoc);
  const [isLoading, setIsLoading] = useState(true);

  // Pagination
  const [page, setPage] = useState(1);
  const [hasNextPage, setHasNextPage] = useState(false);
  const [hasPrevPage, setHasPrevPage] = useState(false);
  const [total, setTotal] = useState(0);
  const [pages, setPages] = useState(0);

  const [order, setOrder] = useState("id-desc");
  const request = useAxios();

  const refetchDocs = () => getDocs({ page: page, limit: limit });

  const [systemId, setSystemId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  useEffect(() => {
    getDocs({ page, limit });
  }, [page, limit, order]);

  async function getDocs({ page, limit }) {
    let res = await request({
      method: "GET",
      url: "customers/all",
      params: {
        page,
        limit,
        order,
      },
      show_loading: false,
      loadingFunc: setIsLoading,
    });

    if (res === "error") return;

    setTotal(res?.pagination?.total || 0);
    setPages(res?.pagination?.pages || 0);
    setHasNextPage(res?.pagination?.hasNextPage || false);
    setHasPrevPage(res?.pagination?.hasPrevPage || false);
    setDocs(res?.docs || initDoc);
  }

  function handleNext() {
    if (hasNextPage) setPage((prev) => prev + 1);
  }

  function handlePrev() {
    if (hasPrevPage) setPage((prev) => prev - 1);
  }

  async function handleDelete(id) {
    let res = await request({
      method: "DELETE",
      url: `customers/delete/${id}`,
      params: { id: parseInt(id) },
    });

    if (res !== "error") {
      setShowDeleteModal(false);
      refetchDocs();
    }
  }

  return {
    limit,
    setLimit,
    docs,
    setDocs,
    isLoading,
    setIsLoading,
    pagination: {
      page,
      total,
      pages,
      hasNextPage,
      hasPrevPage,
      handleNext,
      handlePrev,
      limit,
      setLimit,
      total_docs: docs.length || 0,
    },
    setOrder,
    systemId,
    setSystemId,
    refetchDocs,
    showDeleteModal,
    setShowDeleteModal,
    handleDelete,
  };
}

export default useTable;
